import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ec5ddbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto px-4 py-28" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-8 mb-4 text-center text-2xl font-bold" }, " Thank you for your donation. ", -1))
const _hoisted_5 = { class: "my-1 text-center text-md text-gray-500 overflow-x-auto" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Donation id : ")
const _hoisted_7 = { class: "text-black" }
const _hoisted_8 = { class: "my-1 text-center text-md text-gray-500" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" We will send you and order confirmation to ")
const _hoisted_10 = { class: "text-black" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" shortly. ")
const _hoisted_12 = { class: "my-6 flex justify-center" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" OK ")
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex justify-center mb-8" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1 text-center text-xl text-gray-500" }, [
  /*#__PURE__*/_createTextVNode(" Would you like to get complimentary NFTs as memorabilia for your "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" donation? ")
], -1))
const _hoisted_17 = { class: "mt-8 flex md:flex-row flex-col items-center justify-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" No, thank you. ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Yes ")

import { defineComponent, computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import * as api from '@/apis';
import IconDonateSuccess from '@/components/Icons/IconDonateSuccess.vue';
import IconGift from '@/components/Icons/IconGift.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const id = computed(() => route.params.id as string);
const isGetNFT = ref<boolean>(false);

const idShow = ref<string>(id.value);

const email = computed(() => localStorage.getItem('donate_email'));

onMounted(async () => {
  if (route.query.token) {
    const resPaypal = await api.donatePaypalInfo(route.query.token as string);
    const refID = resPaypal.data.purchase_units[0].reference_id;
    const res = await api.donateInfo(refID);
    idShow.value = res.data.objectId;
  } else if (id.value.startsWith('chrg')) {
    const res = await api.donateInfo(id.value);
    idShow.value = res.data.objectId;
  }
});

defineComponent({
  name: 'DonateSuccessView',
});

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isGetNFT.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(IconDonateSuccess)
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(idShow.value), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(email)), 1),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_BaseButton, {
              "color-scheme": "primary",
              height: "40px",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isGetNFT.value = true))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(IconGift)
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_router_link, { to: "/landing" }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  "color-scheme": "border",
                  height: "40px",
                  class: "md:mr-6 md:mb-0 mr-0 mb-3 btn--width",
                  "data-testid": "donate-success-thank"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/landing/receive-nft" }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  "color-scheme": "primary",
                  height: "40px",
                  class: "btn--width",
                  "data-testid": "donate-succes-yes"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}
}

})